import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增/修改应急预案任务
export function updateSort(data) {
    return request({
        baseURL,
        url: '/emergencyPlanTask/updateSort',
        method: 'post',
        data
    })
}
// 新增/修改应急预案任务
export function submit(data) {
    return request({
        baseURL,
        url: '/emergencyPlanTask/submit',
        method: 'post',
        data
    })
}
//查询应急预案任务列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyPlanTask/list',
        method: 'get',
        params
    })
}
//查询应急预案任务
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyPlanTask/detail?id=' + id,
        method: 'get',
    })
}
//删除应急预案任务
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyPlanTask/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}